define('core/extensions/helpers/tag',[
    'handlebars',
], function (
    Handlebars
) {
    'use strict';

    // This is a simple tag helper concept for making links inside translations simpler.
    return function (tagname, options) {
        var el = ['<' + tagname ];
        // Can't use any HTML in `text`
        var text = options.hash.text;
        delete options.hash.text;
        for (var key in options.hash) {
            if (options.hash.hasOwnProperty(key))
                el.push(' ' + key + '="' + Handlebars.escapeExpression(options.hash[key]) + '"');
        }
        el.push('>' + Handlebars.escapeExpression(text) + '</' + tagname + '>');
        return new Handlebars.SafeString(el.join(''));
    };
});

